export default __webpack_public_path__ + "4af4b92aaca4e06ffc81b948cfb8febc.png";